class _TvConsoleHelper {
    constructor() {
        this.prevBrokerConfigFlags = null;
        this.prevAllowedDurations = null;
        this.debugMode = false;
        this.needLogExecutions = false;
    }
    setBrokerConfigFlags(flags) {
        this.prevBrokerConfigFlags = flags;
    }
    setAllowedDurations(durations) {
        this.prevAllowedDurations = durations;
    }
    getBrokerConfigFlags() {
        console.warn(this.prevBrokerConfigFlags);
    }
    getAllowedDurations() {
        console.warn(this.prevAllowedDurations);
    }
    changeDebugMode() {
        this.debugMode = !this.debugMode;
        console.warn('Debug mode is ', this.debugMode ? 'enabled' : 'disabled');
        console.warn('Try to relogin to apply changes');
    }
    getDebugMode() {
        return this.debugMode;
    }
    changelogExcections() {
        this.needLogExecutions = !this.needLogExecutions;
        console.warn('Excecution logging is ', this.needLogExecutions ? 'enabled' : 'disabled');
    }
    isExececutionLoggingEnabled() {
        return this.needLogExecutions;
    }
}
export const tvch = new _TvConsoleHelper();
